<ms-sport-list-body [topGroup]="hasTopGroup" [isMobile]="false" />
@if (isDesktopResolution) {
    <div class="az-close" (click)="closeMenu($event)"><i class="theme-ex"></i></div>
}
